module.exports = __webpack_public_path__ + "static/img/quizzort_top_board.6dfaa0c1.png";